import getJobStatusOrSubStatusLabel from "@utils/getJobStatusOrSubStatusLabel"

import { Skeleton } from "@particles/index"

import { ObjectStatusBadge } from "@molecules"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import { JobPreviewStatusBadgeProps } from "./JobPreviewStatusBadge.types"

export default function JobPreviewStatusBadge(props: JobPreviewStatusBadgeProps) {
    const { statusLabel, substatusLabel, startTime } = props
    const { isLoading } = useJobPreviewCard()

    const statusLabelOverride = getJobStatusOrSubStatusLabel({
        status_label: statusLabel,
        substatus_label: substatusLabel,
    } as Job)

    if (isLoading && (!startTime || !statusLabel)) {
        return (
            <div>
                <Skeleton width={80} height={24} />
            </div>
        )
    }

    return (
        <ObjectStatusBadge objectType="job" status={statusLabel} statusLabelOverride={statusLabelOverride} size="sm" />
    )
}
